import { render, staticRenderFns } from "./ProvinceCityArea.vue?vue&type=template&id=4ad30cee&scoped=true&"
import script from "./ProvinceCityArea.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad30cee",
  null
  
)

export default component.exports